// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-found-page{padding:150px 0}.not-found-page .v-header{padding-bottom:50px}.not-found-page .v-header h1{font-size:75px;font-weight:900;padding-bottom:24px}.not-found-page .v-body{text-align:center;padding-bottom:20px}.not-found-page .v-body a.pod .desc{color:#444;padding-top:10px;font-size:14px;padding-bottom:50px}.not-found-page .v-body a.pod .header{font-size:20px}.not-found-page .v-body i{font-size:70px}", ""]);
// Exports
module.exports = exports;
